module.exports = __webpack_public_path__ + "static/media/2@1920w.f7320db0.jpg";